export default __webpack_public_path__ + "static/media/Checo-GPMexico(1140x475).5ed2c9ab.webp";